import React from "react";
import "./Features.css";

import vrIcon from "../assets/vr-headset (2).png";
import JoystickIcon from "../assets/vr-controller (1).png";
import monitoringIcon from "../assets/pulse (1).png";

const Features: React.FC = () => {
  return (
    <section className="features">
      <div className="container">
        <h2 className="features-title">Efficient VRET Solution</h2>

        <div className="features-grid">
          
          <div className="feature-card">
            <div className="feature-icon">
              <img src={vrIcon} alt="VRET Icon" />
            </div>
            <h3>Immersive VRET Technology</h3>
            <p>
              3D environments designed for high ecological validity.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <img src={JoystickIcon} alt="Controlled Exposure Icon" />
            </div>
            <h3>Controlled Exposure Environment</h3>
            <p>
              Controlled and safe exposure for consistent therapeutic results.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <img src={monitoringIcon} alt="Monitoring Icon" />
            </div>
            <h3>Remote Client Monitoring</h3>
            <p>
              High-fidelity VRET delivery from the clinic or at home.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Features;
